import { getAboutPage } from "../../../config/aboutContent.js";
import { buildAnimatedHeading } from "../../HeroTitleAnimation.js";
import { buildSectionPillRow } from "../../components/SectionPill.js";

export function createAboutCtaSection() {
  const { cta } = getAboutPage();
  const section = document.createElement("section");
  section.id = "next";
  section.className = "section about-cta";

  section.innerHTML = `
    <div class="section__inner">
      <div class="about-cta__card reveal">
        <div class="about-cta__glow" aria-hidden="true"></div>
        ${buildSectionPillRow(cta.badge)}
        <h2 class="about-cta__title">${buildAnimatedHeading(cta.titleSegments)}</h2>
        <p class="about-cta__subtitle">${cta.subtitle}</p>
        <div class="about-cta__actions">
          <a class="btn btn--primary" href="${cta.primaryHref}">${cta.primary}</a>
          <a class="btn btn--ghost" href="${cta.secondaryHref}">${cta.secondary}</a>
        </div>
      </div>
    </div>
  `;

  return section;
}
